var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 492,
    viewBox: "0 0 402 492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M351.643 67.5851C346.207 31.1518 315.117 4.05952 278.283 3.65729L77.3418 1.46301C32.097 0.968935 -3.27974 40.3492 2.04371 85.2824L42.3045 425.109C47.0355 465.042 82.4178 494.138 122.512 491.066L331.183 475.081C374.592 471.756 406.058 432.292 399.633 389.233L351.643 67.5851Z",
    stroke: "#487E6F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7.5 7.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashes);
export default __webpack_public_path__ + "static/media/dashes.64198f89e0b22f8a478c4bb62dee2ee3.svg";
export { ForwardRef as ReactComponent };